import React, { useCallback } from "react";
import BundleItemsSlider from "./components/bundle-Items-slider";
import ProductBox from "../product/product-box/ProductBox";
import SvgPlus from "../product/product-box/product-box-helpers/btn-expanding-add-to-card/btn-esxpanding-types/btn-expanding-icons/SvgPlus";
import { getProductBoxDefaultDimAndSpacing } from "../product/common/functions";
import { useGetCompanyQuery } from "@/api/AppApi/services/company";
import { IBundleItem } from "@/api/AppApi/services/product/interfaces/product-bundle-types";
import { useBundleProduct } from "./context/BundleProductContext";

const ItemsSection: React.FC<{
  sliderItems: {
    type: "product" | "plus";
    data?: IBundleItem;
    id: string;
    index: number;
  }[];
}> = ({ sliderItems }) => {
  const getCompanty = useGetCompanyQuery();
  const theme = getCompanty?.data?.result?.theme!;
  const size = theme?.components?.product?.product_box_style!;
  const { width, spacing } = getProductBoxDefaultDimAndSpacing(size);
  const widthArray = sliderItems.map((item) =>
    item.type === "product" ? width : "auto",
  );

  const { hanldeChildChange } = useBundleProduct();

  const createBundleSetSelectedChildIndex = useCallback(
    (itemIndex: number) => (childIndex: number | null) => 
      hanldeChildChange(itemIndex, childIndex),
    [hanldeChildChange]
  );

  return (
    <BundleItemsSlider widthArray={widthArray} spacing={spacing}>
      {sliderItems.map((single, key) =>
        single.type === "product" ? (
          <>
            {!!single.data?.product && (
              <ProductBox
                isGrid={false}
                key={key}
                size={size}
                scrollableTabs={false}
                theme={theme}
                priority={false}
                {...single.data?.product}
                hideAddToCart
                showAllAttributes
                bundleSetSelectedChildIndex={createBundleSetSelectedChildIndex(single.index)}
              />
            )}
          </>
        ) : (
          <div
            key={key}
            className=" d-flex align-items-center justify-content-center h-100"
          >
            <PlusIcon />
          </div>
        ),
      )}
    </BundleItemsSlider>
  );
};

export default ItemsSection;

const PlusIcon = () => (
  <div className="bundle-plus">
    <SvgPlus />
  </div>
);
